import React from "react";
import "./styles/CeoOrganizationChart.scss";
import { useTranslation } from "react-i18next";

const CeoOrganizationChart = () => {
  const { t } = useTranslation();

  const mainOffice = t("aboutUs.ceo.organizationChart.content.mainOffice");
  const affiliate = t("aboutUs.ceo.organizationChart.content.affiliate", { returnObjects: true }) as string[][];
  const department = t("aboutUs.ceo.organizationChart.content.department", { returnObjects: true }) as { title: string; list: { main: string; sub: string }[] }[];

  return (
    <>
      <div id="ceo_organization_chart_wrap">
        <h2 className="title">
          Organization Chart <br />
          {t("aboutUs.ceo.organizationChart.title")}
        </h2>
        <div className="content">
          <div className="organization_chart_wrap">
            <div className="representative_company_wrap">{mainOffice}</div>
            <div className="affiliate_company_wrap">
              {affiliate.map((group, index) => {
                return (
                  <div className={`company_group_wrap ${index === 1 ? "down" : ""}`} key={`group_${index}`}>
                    {group.map((company, index2) => {
                      return (
                        <div className={`company_wrap ${index === 0 ? "green" : index === 1 ? "red" : ""}`} key={`${company}_${index2}`}>
                          {company}
                        </div>
                      );
                    })}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="departments_wrap">
            {department.map((data, index) => {
              return (
                <div className="card" key={`departments_${index}`}>
                  <div className="title">{data.title}</div>
                  <ul>
                    {data.list.map((list, index2) => {
                      return (
                        <li key={`list_${index2}`}>
                          {list.main}
                          <div className="sub">{list.sub}</div>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CeoOrganizationChart;
